module.exports = __webpack_public_path__ + "img/head-img.78cd3327.png";